import React, { useState } from "react";
import { FiArrowRight, FiHeart, FiPackage, FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";
import PageMeta from "./PageMeta";
import "../css/account.scss";

const Account = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submit = (event) => {
    event.preventDefault();
    setMessage(
      `A secure sign-in link would be sent to ${email} in a connected storefront.`
    );
  };

  return (
    <main className="account-page">
      <PageMeta title="Your account" />
      <section className="account-hero">
        <div className="container">
          <p className="eyebrow">Join the club</p>
          <h1>Your table, remembered.</h1>
          <p>
            Keep favourites close, see past orders and make the next shop
            quicker.
          </p>
        </div>
      </section>
      <section className="container account-layout">
        <div className="account-card">
          <span className="account-card__icon">
            <FiUser />
          </span>
          <p className="eyebrow">Sign in</p>
          <h2>Welcome back</h2>
          <p>
            Enter your email to continue to your customer account.
          </p>
          <form onSubmit={submit}>
            <label htmlFor="account-email">Email address</label>
            <input
              id="account-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <button className="button button--primary" type="submit">
              Continue securely <FiArrowRight />
            </button>
          </form>
          {message && (
            <p className="account-message" role="status">
              {message}
            </p>
          )}
        </div>
        <aside className="account-benefits">
          <p className="eyebrow">Membership, kept simple</p>
          <h2>A little more useful every visit.</h2>
          <div>
            <FiHeart />
            <span>
              <b>Save your favourites</b>
              <small>Build a shortlist for the next board.</small>
            </span>
          </div>
          <div>
            <FiPackage />
            <span>
              <b>Find past orders</b>
              <small>Revisit the good things in a connected store.</small>
            </span>
          </div>
          <div>
            <FiUser />
            <span>
              <b>Quicker checkout</b>
              <small>Keep delivery details ready for next time.</small>
            </span>
          </div>
          <Link className="text-link" to="/shop">
            Browse as a guest <FiArrowRight />
          </Link>
        </aside>
      </section>
    </main>
  );
};

export default Account;
